
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "allUser",
})
export default class allUser extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  
  data() {
        return {
          options1: [{
            value1: '选项1',
            label1: '禁用余额'
          }, {
            value1: '选项2',
            label1: '启用余额'
          }],
          value1: '',
		  options2: [{
		    value2: '选项1',
		    label2: '禁用评论'
		  }, {
		    value2: '选项2',
		    label2: '启用评论'
		  }],
		  value2: ''
        }
    }

  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    let datas = [];
    let type = 2;
    let paramter = {
    	pageSize:1,
		pageNum:10
    };
    this.$http.get("user/list", {paramter}).then((res: any) => {
    	datas = res.data.data.data;
    	this.tableData = datas;
    	this.tableData = this.tableData.map(item=>{
        if(item.ifWallet == null || item.ifWallet == 1 ) {

          item.ifWallet = true;
        } else {

          item.ifWallet = false;
        }
        if(item.ifAssess == null || item.ifAssess == 1) {

          item.ifAssess = true;
        } else {

          item.ifAssess = false;
        }
		if(item.enable == 1) {
			
			item.enable = true;
		} else {
			
			item.enable = false;
		}
    		return item;
    	});
    	console.log('普通用户',this.tableData);
    });
  }
  // 修改权限
  private editPower(value: any,inteValue: number){
    let item = value;
	let inteValue4 = inteValue;
	// inteValue 1:修改余额权限 2.修改评论权限 3.是否禁用用户权限
	let enable;
	let url;
	if(inteValue4 == 1){
		
		enable = item.ifWallet== true?1:0;
		url = 'user/edit/power/wallet';
	} else if(inteValue4 == 2) {
		
		enable = item.ifAssess== true?1:0;
		url = 'user/edit/power/assess';
	} else {
		
		enable = item.enable == true?1:0;
		url = 'user/edit/enable';
	}
    let paramter = {
		id:item.id,
    	enable:enable
    };
    this.$http.put(url, paramter).then((res: any) => {
    	
		let data = res.data;
		if(data.code == 200) {
			
			let content = enable==1?'开启权限':'关闭权限';
			this.$message({
			    message: content,
			    type: 'success'
			});
			
		} else {
			
			this.$message.error(data.msg);
		}
		
    });
  }
  // // 修改评论权限
  // private editAssess(value: any){
	  
	 //  let item = value;
	 //  let ifWallet = item.ifWallet== true?1:0;
	 //  let paramter = {
	 //  	id:item.id,
	 //  	enable:ifWallet
	 //  };
	 //  this.$http.put('user/edit/power/wallet', paramter).then((res: any) => {
	  	
	 //  	let data = res.data;
	 //  	console.log('data = ',data);
	 //  	if(data.code == 200) {
	  		
	 //  		let content = ifWallet==1?'开启权限':'关闭权限';
	 //  		this.$message({
	 //  		    message: content,
	 //  		    type: 'success'
	 //  		});
	 //  	} else {
	  		
	 //  		this.$message.error(data.msg);
	 //  	}
	  	
	 //  	console.log('普通用户',res);
	 //  });
  // }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }
  private balanceStateChange(value: any) {
	  
	  // 余额权限
    let item = value;
	let inteValue1 = 1;
    this.editPower(item,inteValue1);
  }
  private userStateChange(value: any){
	  
	  // 评论权限
	let item = value;
	let inteValue2 = 2;
	this.editPower(item,inteValue2);
  }
  private userIsDisableChange(value: any){
	  
	  //账号禁用启用
	  let item = value;
	  let inteValue3 = 3;
	  this.editPower(item,inteValue3);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleBalance(index,row){
	  
	  console.log(row);
	  this.$router.push('/User/editBalance/?id='+row.id);
  }
  private handleEdit(index,row){
  	  
  	  console.log(row);
	  this.$router.push('/User/editUser/?id='+row.id)
  }
}
